module.exports = __webpack_public_path__ + "static/img/bg.fafa550.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/artistry/makeover/images/bg.png
// module id = U7yW
// module chunks = 0